import React, { ReactElement } from "react";

import "./ShoppingHero.scss";
export default function ShoppingHero(): ReactElement {
  return (
    <div className="shopping-hero">
      <div className="shopping-hero-content">
        <h1>Furtech Shopping</h1>
        <p>
          Offers wide products selection, bringing new trends to the market,
          providing good Quality products and reliable services to our valued
          customers.
        </p>
      </div>
    </div>
  );
}
